import React, { useState } from 'react';
import { Typography, Button, FormControlLabel, Checkbox, Link, FormHelperText } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CouponSelector from './CouponSelector';

function OrderNotPayment({
    formData,
    totalPrice,
    getSumTotal,
    goBack,
    handleOrder,
    loading,
    couponData,
    onSelectCoupon,
    selectedCoupon,
    user,               // nuova prop
}) {

    const [termsAccepted, setTermsAccepted] = useState(false);
    const [error, setError] = useState(false);

    const onSubmit = () => {
        if (user?.id === 'anonymus' && !termsAccepted) {
            setError(true);
            return;
        }
        setError(false);
        handleOrder();
    };

    return (
        <>

            <CouponSelector
                couponData={couponData}
                onSelect={onSelectCoupon}
                selectedCoupon={selectedCoupon}
                getSumTotal={getSumTotal}
            />
            <Typography style={{ letterSpacing: '1px' }} variant="subtitle1" gutterBottom>
                Subtotale: {totalPrice.toFixed(2).replace('.', ',')} €
            </Typography>

            {formData.deliveryOption.toLowerCase() === 'consegna' && (
                <Typography style={{ letterSpacing: '1px' }} variant="subtitle1" gutterBottom>
                    Spese di consegna: {Number(formData.costoConsegna).toFixed(2).replace('.', ',')} €
                </Typography>
            )}

            {selectedCoupon && (
                <Typography style={{ letterSpacing: '1px', }} color='primary' variant="subtitle1" gutterBottom>
                    Sconto: -{Number(selectedCoupon.value).toFixed(2).replace('.', ',')} €
                </Typography>
            )}

            <Typography style={{ letterSpacing: '1px' }} variant="h5" gutterBottom>
                Totale: {getSumTotal().toFixed(2).replace('.', ',')} €
            </Typography>

            {user?.id === 'anonymus' && (
                <>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={termsAccepted}
                                onChange={(e) => {
                                    setTermsAccepted(e.target.checked);
                                    if (e.target.checked) setError(false);
                                }}
                                name="termsAccepted"
                                color="primary"
                            />
                        }
                        label={
                            <Typography variant="body2" component="span" sx={{ userSelect: 'none' }}>
                               * Accetto{' '}
                                <Link href="/terms" target="_blank" rel="noopener noreferrer" underline="hover">
                                    termini e condizioni
                                </Link>{' '}
                                e {' '}
                                <Link href="/privacy" target="_blank" rel="noopener noreferrer" underline="hover">
                                    informativa privacy
                                </Link>{' '}
                            </Typography>
                        }
                        sx={{ mt: 2 }}
                    />
                    {error && (
                        <FormHelperText error sx={{ ml: 0 }}>
                            Devi accettare i termini e l&apos;informativa privacy per procedere.
                        </FormHelperText>
                    )}
                </>
            )}

            <div style={{ width: '100%', flexWrap: 'wrap', gap: '5px', marginTop: '30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                    variant="contained"
                    color="secondary"
                    size='small'
                    onClick={() => goBack()}
                    startIcon={<ArrowBackIcon />}
                >
                    Indietro
                </Button>
                <Button
                    size='small'
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowForwardIcon />}
                    onClick={onSubmit}
                    disabled={loading}
                >
                    {'Invia ordine'}
                </Button>
            </div>
        </>

    )
}

export default OrderNotPayment